module.exports = (__parcel__import__("5YwrP")).then(() => parcelRequire('g36Vt'));